import {CountUp} from "countup.js";


export function initCountUp() {
    const countupElements = document.querySelectorAll("[data-countup-number]");
    if (countupElements.length > 0) {
        for (const countUpElement of countupElements) {
            const target = parseInt(countUpElement.getAttribute("data-countup-number")) ?? 0;
            const countUp = new CountUp(countUpElement, target, {
                duration: 3,
                enableScrollSpy: true,
                useEasing: false,
                scrollSpyOnce: true,
            })
            countUp.start()
        }
    }
}